import CommenService from '@/service/index.js';
import Service from '../invoice-pro-service.js';
import Pagination from '@/components/pagination/index.vue';
import { errorMessage } from '@/utils/message.js';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      currentProjectId: '',
      invoiceStatus: [],
      total: 0,
      tableList: [],
      searchForm: {
        projectName: '',
        projectCode: '',
        status: '',
        pageNum: 1,
        pageSize: 5
      },
      showRule: false,
      actionId: ''
    };
  },
  created() {
    const obj = {
      INVOICE_STATUS: 'invoiceStatus'
    };
    Object.keys(obj).forEach((key) => {
      CommenService.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = [{code: '', value: '全部'}, ...res.data];
        }
      });
    });
    this.getInvoiceList();
  },
  computed: {
  },
  methods: {
    indexMethod(index) {
      return (Number(this.searchForm.pageNum) - 1) * Number(this.searchForm.pageSize) + index + 1;
    },
    // 获取发票列表
    getInvoiceList(page){
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      Service.getInvoiceList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    search() {
      this.getInvoiceList();
    },
    clear () {
      this.searchForm = {
        projectName: '',
        status: '',
        startTime: '',
        endTime: '',
        pageNum: 1,
        pageSize: 5
      };
      this.getInvoiceList();
    },
    applyInvoice(item) {
      this.$router.push({path: '/person-center/invoice-pro/applyInvoice', query: {projectId: item.projectId, bidId: item.bidId}});
    },
    goToDetail (item) {
      this.$router.push({path: '/person-center/invoice-pro/detail', query: {projectId: item.projectId, bidId: item.bidId, projectType: item.projectType}});
    },
    ruleShow() {
      this.showRule = true;
    }
  }
};
